/**
 * @template [T=any]
 * @param {Response} response
 * @returns {Promise<import("../../types/alfred/ApiResponse").ApiResponse<T> | undefined>}
 */
export async function getResponseParsedJson(response) {
  if (!response?.headers?.get?.("Content-Type")?.includes("application/json")) {
    return undefined;
  }
  try {
    return await response.json();
  } catch (error) {
    return undefined;
  }
}
